/**
 * @generated SignedSource<<7561e51d0803b21b1bba0fd44f34facf>>
 * @relayHash aad67a04da810466b2420f33d733aa8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e99316c7460036944576db2186b86340e115f6e08c6f04fa808d83adfdc3b9e8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainCompleteSprintMetadataQuery } from './mainCompleteSprintMetadataQuery.graphql';

const node: PreloadableConcreteRequest<mainCompleteSprintMetadataQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e99316c7460036944576db2186b86340e115f6e08c6f04fa808d83adfdc3b9e8",
    "metadata": {},
    "name": "mainCompleteSprintMetadataQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
